import { Menu } from 'lucide-react'
import BSDLogo from './BSDLogo'
import UserMenu from './UserMenu'

interface HeaderProps {
  onMenuOpen?: () => void
}

export function Header({ onMenuOpen }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-left">
        <button className="btn-info" onClick={onMenuOpen} title="Menu sezioni" style={{ marginRight: 8 }}>
          <Menu size={18} />
        </button>
        <div className="logo">
          <BSDLogo size={30} />
          <div className="logo-text">
            <span className="logo-title">BRIANZA SOCIAL DEBUG</span>
            <span className="logo-sub">Dashboard monitoraggio socio-sanitario</span>
          </div>
        </div>
      </div>
      <div className="header-center" />
      <div className="header-right">
        <UserMenu />
      </div>
    </header>
  )
}
